// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedMicroscopeHead_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 13.9991V6.99805L21.2237 6.99805L21.9278 9.62585L21.029 12.98L22.9609 13.4977L23.9938 9.64287L24 9.63208L22.7585 4.99874L22.2657 4.99805H17.421C16.4574 3.81663 14.3922 3 12 3C9.60784 3 7.54264 3.81663 6.57899 4.99805H1.73434L1.2415 4.99874L0 9.63208L0.00623109 9.64287L1.03913 13.4977L2.97098 12.98L2.07222 9.62585L2.77634 6.99805L6 6.99805V13.9991C6.00028 14.8165 6.36839 15.5776 7 16.2109V17.5C7 19.433 9.23858 21.0008 12 21.0008C14.7614 21.0008 17 19.4338 17 17.5008V16.2109C17.6316 15.5776 17.9997 14.8165 18 13.9991ZM14.9983 17.4646C14.1162 17.8045 13.0922 17.9991 12 17.9991C10.9078 17.9991 9.88381 17.8045 9.00167 17.4646C9.00049 17.4779 9 17.49 9 17.5008C9 17.6356 9.07541 17.9621 9.61139 18.3372C10.1411 18.708 10.9793 19.0008 12 19.0008C13.0207 19.0008 13.8589 18.708 14.3886 18.3372C14.9246 17.9621 15 17.6356 15 17.5008C15 17.49 14.9995 17.4779 14.9983 17.4646ZM16 13.9991C16 14.2269 15.8615 14.6779 15.1332 15.1634C14.419 15.6396 13.3171 15.9991 12 15.9991C10.6829 15.9991 9.581 15.6396 8.86676 15.1634C8.13854 14.6779 8 14.2269 8 13.9991V6.5C8 6.49367 8.00052 6.48125 8.00915 6.45666C8.01847 6.4301 8.0404 6.38099 8.09067 6.31166C8.19565 6.16688 8.40384 5.96342 8.7651 5.75268C9.49436 5.32729 10.6336 5 12 5C13.3664 5 14.5056 5.32729 15.2349 5.75268C15.5962 5.96342 15.8044 6.16688 15.9093 6.31166C15.9596 6.38099 15.9815 6.4301 15.9909 6.45666C15.9995 6.48125 16 6.49367 16 6.5V13.9991Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedMicroscopeHead is a generated icon component.
 */
let IconMedMicroscopeHead = IconMedMicroscopeHead_1 = class IconMedMicroscopeHead extends IconBaseElement {
    render() {
        return html `${IconMedMicroscopeHead_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedMicroscopeHead.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedMicroscopeHead = IconMedMicroscopeHead_1 = __decorate([
    customElement('zui-icon-med-microscope-head')
], IconMedMicroscopeHead);
export { IconMedMicroscopeHead };
